import { useState, useEffect, Fragment } from 'react';
// import { Link } from 'react-router-dom';
// import _, { result } from 'lodash';
// import axios from 'axios';

import { useStore } from '../../hook-store/store';

import { 
  getCustomerSubscriptions,
  getUsageBasedConfig,
} from '../../utils/stripe/usage-based-billing-utils';
// import * as bucketObjectUtils from '../../../utils/bucket/bucket-object-util';
// import * as fileMoveUtils from '../../../utils/bucket/file-move-util';
// import * as objectAccessUtils from '../../../utils/bucket/object-access-util';

// import { SUBSCRIPTION_BACKEND_URL } from '../../App';
// import { 
//   BACKEND_URL,
//   // SUBSCRIPTION_BACKEND_URL,  
// } from '~config/endpoints';
import { 
  // BACKEND_URL,
  TEXTAUDIOTOOLSNODE_URL,
 } from '../../App';

function GetUsageBasedSubscription(props) {

  const [store, dispatch] = useStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    usageBasedPrice, 
  } = store.stripeData;

  const { gLoading } = store.uiStore;


  useEffect(() => {
    getUsageBasedPrice();
  },[]);

    useEffect(() => {
      if (usageBasedPrice) {
        getUsageBasedSubscription();
        getUsageBasedConfigHandler();
      }
  },[usageBasedPrice]);
  

   const getUsageBasedPrice = async () => {
    try {
      const result = await fetch(TEXTAUDIOTOOLSNODE_URL + `/usage-based-billing/usage-based-billing-price/?service=text-audio`, {
        // method: 'GET',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
        }
      );

      const resData = await result.json();
      
      // console.log('usage based price', result, resData);
      
      if (resData.data) {
        dispatch('SET_USAGEBASEDPRICE', resData.data);
      }

      return resData;

    } catch(err) {
      console.log(err);
      throw err;
    }
  };

  const getUsageBasedSubscription = async () => {
    try {
      const customerId = localStorage.getItem('customerId');
      // const result = await fetch(BACKEND_URL + `/usage-based-billing/customer-subscriptions/?customerId=${customerId}`, {
      //   // method: 'GET',
      //     headers: {
      //       Authorization: 'Bearer ' + localStorage.getItem('token'),
      //       'Content-Type': 'application/json',
      //       'Accept': 'application/json'
      //     },
      //   }
      // );

      // const resData = await result.json();
      const resData = await getCustomerSubscriptions(
        TEXTAUDIOTOOLSNODE_URL,
        localStorage.getItem('token'),
        customerId,
      )
      
      // console.log('usage based subscription', result, resData);
      
      if (resData?.data) {
        const usageBasedSubscription = resData.data.find(ele => {
          return ele.plan.id === usageBasedPrice.id
        });
        // console.log('usage based subscription', usageBasedSubscription);
        if (usageBasedSubscription) {
          dispatch('SET_USAGEBASEDSUBSCRIPTION', usageBasedSubscription);
        }

      }

      return resData;

    } catch(err) {
      console.log(err);
      throw err;
    }
  };

  const getUsageBasedConfigHandler = async () => {
    try {

      const resData = await getUsageBasedConfig(
        TEXTAUDIOTOOLSNODE_URL,
        localStorage.getItem('token'),
        'text-audio',
      )
      
      // console.log('usage based subscription', result, resData);
      
      if (resData?.data) {
        dispatch('SET_USAGEBASEDCONFIG', resData.data);
      };

      return resData;

    } catch(err) {
      console.log(err);
      throw err;
    }
  };

  // const getSubscriptionConfig = async () => {
  //   try {
  //     const result = await fetch(SUBSCRIPTION_BACKEND_URL + '/subscription/subscription-config', {
  //       // method: 'GET',
  //         headers: {
  //           Authorization: 'Bearer ' + localStorage.getItem('token'),
  //           'Content-Type': 'application/json',
  //           'Accept': 'application/json'
  //         },
  //       }
  //     );

  //     const resData = await result.json();
      
  //     console.log('subscription config', result, resData);
      
  //     if (resData.data) {
  //       dispatch('SET_SUBSCRIPTIONCONFIG', resData.data);
  //     }

  //     return resData;

  //   } catch(err) {
  //     console.log(err);
  //     throw err;
  //   }
  // };




  return (
    <Fragment>
    </Fragment>
  );
}

export default GetUsageBasedSubscription;
